export default {"src":"/_next/static/media/12.5fb3b113.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};